import {
  ReservationUsers,
  RoundRobinAvailableAttendees,
} from '@chilipiper/api-client/src/user-availability'
import { OwnershipLinkRoutingResult } from '../../load-meeting-attempt'
import { isStrictRoundRobinAssignees, hasFlexibleRoundRobinAssignees } from '../../load-slots/types'
import { isMixedResults } from '../../load-meeting-attempt'
import { isOwnerFromSimpleRule } from '../../load-meeting-attempt'
import { isWithDistribution } from '../../load-meeting-attempt'

export const getOwnershipReservationUsers = ({
  availableUsers,
  ownershipResult,
  additionalAttendees,
  userIds,
}: {
  userIds?: string[]
  availableUsers?: RoundRobinAvailableAttendees[]
  ownershipResult: OwnershipLinkRoutingResult
  additionalAttendees?: string[]
}): ReservationUsers | undefined => {
  if (
    (isWithDistribution(ownershipResult) || isMixedResults(ownershipResult)) &&
    isStrictRoundRobinAssignees(availableUsers)
  ) {
    const attendeesFromDistribution = availableUsers.map(assignee => {
      return {
        userId: assignee.userId,
        distributionId: assignee.distributionId,
      }
    })
    return {
      type: 'DistributionUsers',
      additionalAttendees,
      attendeesFromDistribution,
    }
  }

  if (isOwnerFromSimpleRule(ownershipResult) && isStrictRoundRobinAssignees(availableUsers)) {
    return {
      type: 'UsersWithLimit',
      limit: {
        type: 'NoMeetingLimit',
      },
      userIds: availableUsers.map(assignee => assignee.userId),
    }
  }

  if (
    isMixedResults(ownershipResult) &&
    !hasFlexibleRoundRobinAssignees(availableUsers) &&
    userIds?.length
  ) {
    // When we only have owners result we should pick the owners in userIds param
    return {
      type: 'UsersWithLimit',
      limit: {
        type: 'NoMeetingLimit',
      },
      userIds,
    }
  }
}
